import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Em SPA o React Router preserva a posição do scroll ao trocar de rota — então,
 * clicar num link (ex: no rodapé público) levava à nova página com o scroll ainda
 * no rodapé. Este componente reseta o scroll para o topo a cada mudança de rota.
 *
 * Exceção: navegação com âncora (`/#recursos`) — aí o alvo é uma seção, não o topo;
 * deixamos o `scrollIntoView` do próprio link cuidar disso.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
